import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Icons
import { IconDefinition, faPencil, faLightbulb, faDollarSign, faHeart } from '@fortawesome/free-solid-svg-icons';

import styles from './contestStats.module.scss';


interface IStatsItem {
  icon: IconDefinition;
  name: string;
  value: number | string;
}

const StatsItem: React.FC<IStatsItem> = ({ icon, name, value }) => {


  return (
    <div className={`d-flex flex-column justify-content-center align-items-center text-center mb-4 px-4`} style={{ minWidth: '100px' }}>
      <div className="w-100 d-flex justify-content-center align-items-center text-center" style={{ height: '35px' }}>
        <FontAwesomeIcon icon={icon as IconProp} className="text color-blue" />
      </div>
      <div className={`title  d-flex justify-content-center align-items-center text-center`} >
        {value}
      </div>
      <div className="text-12 text-center">{name}</div>
    </div>
  );
};

interface IContestStats {
  entries?: number;
  inspirations?: number;
  awards?: number;
  votes?: number;
}

const ContestStatsWLF: React.FC<IContestStats> = ({awards, entries, inspirations, votes}) => {

  return (
    <div className={`d-flex flex-row justify-content-end ${styles.statsWrapper}`}>
      <div className="d-flex flex-row justify-content-end bg-light radius-m">
        {awards !== 0 ? (
          awards && <StatsItem name="total awards" value={'€ ' + awards} icon={faDollarSign} /> //clickable={clickableAwards()}
        ) : (
          <StatsItem name="total awards" value={'-'} icon={faDollarSign} /> //clickable={clickableAwards()}
        )}

        {entries !== 0 ? (
          entries && <StatsItem name="entries" value={entries} icon={faPencil} /> //clickable={clickableEntries()}
        ) : (
          <StatsItem name="entries" value={0} icon={faPencil} /> //clickable={clickableEntries()}
        )}
        {
          inspirations !== 0 && inspirations && <StatsItem name="inspirations" value={inspirations} icon={faLightbulb} /> //clickable={clickableInspirations()}
        }
        {
          votes !== 0 && votes && <StatsItem name="votes received" value={votes} icon={faHeart} /> //clickable={clickableEntries()}
        }
      </div>
    </div>
  );
};

export default ContestStatsWLF;
